export const SearchIcon = ({
  fill = '#1AA85D',
  width = '100%',
  className = '',
  height = '100%',
  viewBox = '0 0 16 16',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    className={className}
  >
    <path
      // eslint-disable-next-line max-len
      d="M12.64 7.21036C12.64 4.21014 10.2084 1.77785 7.20884 1.77785C4.20934 1.77794 1.77769 4.2102 1.77769 7.21036C1.77782 10.2104 4.20942 12.6419 7.20884 12.642C8.67859 12.642 10.0112 12.0575 10.989 11.109C11.007 11.0872 11.026 11.0659 11.0463 11.0456C11.0664 11.0255 11.0874 11.0069 11.1088 10.9892C12.0562 10.0114 12.6399 8.67947 12.64 7.21036ZM14.4177 7.21036C14.4176 8.88014 13.8479 10.4154 12.8952 11.6376L15.7397 14.4824C16.0868 14.8295 16.0868 15.3931 15.7397 15.7402C15.3925 16.0871 14.8298 16.0864 14.4828 15.7394L11.6392 12.8955C10.4167 13.8498 8.8798 14.4199 7.20884 14.4199C3.22751 14.4198 0.000130549 11.1922 0 7.21036C0 3.22844 3.22743 9.39264e-05 7.20884 0C11.1903 0 14.4177 3.22838 14.4177 7.21036Z"
    />
  </svg>
)
